import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const printerDeleteAtom = createMutationAtomFactory(
  'settings.printerDelete',
  (params: { id: string }) => ({
    iotPrinterDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
